import { render, staticRenderFns } from "./HomeV3.vue?vue&type=template&id=820a6e6e"
import script from "./HomeV3.vue?vue&type=script&lang=js"
export * from "./HomeV3.vue?vue&type=script&lang=js"
import style0 from "./HomeV3.vue?vue&type=style&index=0&id=820a6e6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports